import { useContext, useEffect, useState } from 'react'
import Context from './Context'
// Antd
import { Input, message } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
// components
import BaseLayout from 'components/BaseLayout'
import TableComponent from 'components/Table'
import Modal from './Modal'
import { ColumnsType } from 'components/Table/interface'
// helpers
import get from 'lodash/get'
import { render } from 'react-dom'
import ExpirationDate from './Cells/ExpirationDate'

const columns: ColumnsType<any> = [
  {
    title: 'Usuario',
    dataIndex: 'identity_first_name',
    type: 'userCell'
  },
  {
    title: 'Email',
    dataIndex: 'identity_email'
  },
  {
    title: 'Teléfono',
    dataIndex: 'identity_phone'
  },
  {
    title: 'Puntos disponibles',
    dataIndex: 'identity_point_count'
  },
  {
    title: 'Fecha de expiracion',
    dataIndex: 'identity_uuid',
    render: ExpirationDate
  },
  {
    title: '',
    dataIndex: 'identity_uuid',
    type: 'moreOptions',
    fixed: 'right',
    width: 40
  }
]

const Layout: React.FC = () => {
  const {
    states: { filterSelected, page, searchInput, selectedUser },
    actions: { setFilterSelected, setPage, setSearchInput },
    queryHandler: { isFetching, data: dataQuery }
  } = useContext(Context)
  const [filter, setFilter] = useState('')

  const data = get(dataQuery, 'data', [])
  const paginationInfo = get(dataQuery, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 8,
    totalPages: 1,
    totalRecords: 1
  })

  useEffect(() => {
    const time = setTimeout(() => {
      if (filter != searchInput) setSearchInput(filter)
    }, 600)
    return () => clearTimeout(time)
  }, [filter])

  return (
    <>
      <BaseLayout title="Usuarios" bordered={false}>
        <Input
          size="large"
          placeholder="Busca por nombre, email o número celular"
          prefix={<SearchOutlined />}
          value={filter}
          onChange={e => setFilter(() => e.target.value)}
        />
        <TableComponent
          emptyData={data.length === 0 && !isFetching}
          columns={columns}
          data={data}
          rows={9}
          loading={isFetching}
          page={page}
          total={paginationInfo.totalRecords}
          setPage={setPage}
        />
      </BaseLayout>
      <Modal key={selectedUser} />
    </>
  )
}

export default Layout
